import React, { FC } from 'react';

interface NormalButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    title: string;
    title2: string;
    classes: string;
}

export const NormalButton: FC<NormalButtonProps> = (props) => {
    const {
        title, title2, classes, ...args
    } = props;

    return (
        <button type="button" className={classes} {...args}>
            {title}
            {title2}
        </button>
    );
};
